module.exports = __webpack_public_path__ + "img/maze_rectangular_g.0956fcf2.svg";